import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { FC } from "react";
import { Box } from "@mui/material";
import { FieldError } from "./FieldControllerError";

interface FieldControllerProps {
  id: string;
  type?: string;
  autoComplete?: string;
  formHelperTextProps?: any;
  fullWidth?: boolean;
  inputProps?: any;
  rules?: any;
  name: string;
  label: string;
  control: any;
  size?: 'small' | 'medium';
  sx?: any;
  disabled?: boolean;
  helperText?: string;
}

export const FieldController: FC<FieldControllerProps> = ({
  id,
  type,
  autoComplete,
  formHelperTextProps,
  fullWidth,
  inputProps,
  rules,
  name,
  label,
  control,
  size,
  sx,
  disabled,
  helperText,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box sx={{ ...sx, display: "flex", flexDirection: "column" }}>
          <TextField
            fullWidth={fullWidth}
            id={id}
            type={type}
            helperText={!error && helperText}
            error={!!error}
            onChange={onChange}
            value={value}
            label={label}
            autoComplete={autoComplete}
            required={rules?.required}
            disabled={!!disabled}
            size={size}
            slotProps={{
              input: inputProps,
              formHelperText: formHelperTextProps
            }} />
          <FieldError error={error} />
        </Box>
      )}
    />
  );
};
